import React from 'react';
function AccessTime() {
    return (React.createElement("g", null,
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0V0z" }),
        React.createElement("path", { d: "M11,8V20h2V8h3L12,4,8,8Z" })));
}
export default AccessTime;
